import React, { useState } from 'react';
import ClinicLayout from './ClinicLayout';
import { Edit, Trash2, Pill, ChevronDown } from 'lucide-react';

const ClinicManagePatients = () => {
  const [patients] = useState([
    { patientId: '132736616', lastName: 'Rutherford Pettway', firstName: 'Chris', mi: '', dob: '09/10/1993', sex: 'M', patientAcctNo: '', insurance: '', type: 'P', status: 'Active' },
  ]);

  return (
    <ClinicLayout activeTab="manage-patients">
      <div className="p-4 pr-20" data-testid="clinic-manage-patients">
        {/* Sub Navigation Tabs */}
        <div className="flex items-center justify-end mb-2">
          <div className="flex items-center gap-4 text-xs">
            <span className="text-[#2563eb] cursor-pointer hover:underline">Add New Patient</span>
            <span className="text-[#2563eb] cursor-pointer hover:underline flex items-center gap-1">
              Recent Charts <ChevronDown className="w-3 h-3" />
            </span>
            <span className="text-[#2563eb] cursor-pointer hover:underline font-medium">Patient List</span>
            <span className="text-[#2563eb] cursor-pointer hover:underline flex items-center gap-1">
              Reports <ChevronDown className="w-3 h-3" />
            </span>
          </div>
        </div>

        {/* Section Header */}
        <div className="bg-gradient-to-b from-[#4a5568] to-[#2d3748] text-white px-3 py-2 text-sm font-medium mb-4">
          Patient List
        </div>

        {/* Filters */}
        <div className="bg-[#f5f5f5] border border-gray-300 p-3 mb-4">
          <div className="space-y-2 text-xs">
            {/* Row 1 - Search */}
            <div className="flex items-center gap-2">
              <label className="w-16">Search For:</label>
              <select className="border border-gray-400 px-1 py-0.5">
                <option>Patient Last Name</option>
                <option>Patient ID</option>
                <option>Phone Number</option>
              </select>
              <select className="border border-gray-400 px-1 py-0.5">
                <option>Starts With</option>
                <option>Contains</option>
                <option>Equals</option>
              </select>
              <input type="text" className="border border-gray-400 px-1 py-0.5 w-40" />
              <button className="border border-gray-400 px-3 py-0.5 bg-gray-100">Search</button>
              <span className="text-[#2563eb] cursor-pointer hover:underline flex items-center gap-1">
                Show All <ChevronDown className="w-3 h-3" />
              </span>
            </div>

            {/* Row 2 - Display Filters */}
            <div className="flex items-center gap-4">
              <span className="font-medium">Display Filter:</span>
              <div className="flex items-center gap-2">
                <label>Account Type:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex items-center gap-2">
                <label>Status:</label>
                <select className="border border-gray-400 px-1 py-0.5">
                  <option>Active</option>
                  <option>Inactive</option>
                  <option>-- All --</option>
                </select>
              </div>
              <div className="flex-1"></div>
              <span className="text-[#2563eb] cursor-pointer hover:underline flex items-center gap-1">
                Select Actions <span className="text-xs">▶</span>
              </span>
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="border border-gray-300">
          <table className="w-full text-xs">
            <thead>
              <tr className="bg-[#1e3a5f] text-white">
                <th className="p-1 border border-gray-400 w-6"><input type="checkbox" /></th>
                <th className="p-1 border border-gray-400 text-left">Patient ID</th>
                <th className="p-1 border border-gray-400 text-left text-red-400">Last Name</th>
                <th className="p-1 border border-gray-400 text-left">First Name</th>
                <th className="p-1 border border-gray-400 text-center">MI</th>
                <th className="p-1 border border-gray-400 text-left">DOB</th>
                <th className="p-1 border border-gray-400 text-center">Sex</th>
                <th className="p-1 border border-gray-400 text-left">Patient Acct. No</th>
                <th className="p-1 border border-gray-400 text-left">Insurance</th>
                <th className="p-1 border border-gray-400 text-center">Type</th>
                <th className="p-1 border border-gray-400 text-center">Status</th>
                <th className="p-1 border border-gray-400 text-center">Edit</th>
                <th className="p-1 border border-gray-400 text-center">Del</th>
                <th className="p-1 border border-gray-400 text-center">eRx</th>
              </tr>
            </thead>
            <tbody>
              {patients.map((patient, index) => (
                <tr key={patient.patientId} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                  <td className="p-1 border border-gray-300 text-center"><input type="checkbox" /></td>
                  <td className="p-1 border border-gray-300">{patient.patientId}</td>
                  <td className="p-1 border border-gray-300 text-[#2563eb] cursor-pointer hover:underline">{patient.lastName}</td>
                  <td className="p-1 border border-gray-300 text-[#2563eb] cursor-pointer hover:underline">{patient.firstName}</td>
                  <td className="p-1 border border-gray-300 text-center">{patient.mi}</td>
                  <td className="p-1 border border-gray-300">{patient.dob}</td>
                  <td className="p-1 border border-gray-300 text-center">{patient.sex}</td>
                  <td className="p-1 border border-gray-300">{patient.patientAcctNo}</td>
                  <td className="p-1 border border-gray-300">{patient.insurance}</td>
                  <td className="p-1 border border-gray-300 text-center">{patient.type}</td>
                  <td className="p-1 border border-gray-300 text-center">{patient.status}</td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Edit className="w-3 h-3 inline cursor-pointer text-gray-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Trash2 className="w-3 h-3 inline cursor-pointer text-gray-600" />
                  </td>
                  <td className="p-1 border border-gray-300 text-center">
                    <Pill className="w-3 h-3 inline cursor-pointer text-gray-600" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="mt-3 flex items-center justify-between text-xs">
          <div className="flex items-center gap-2">
            <span>|◀ ◀◀</span>
            <span>Page</span>
            <input type="text" className="border border-gray-400 w-8 text-center" defaultValue="1" />
            <span>of 1</span>
            <span>▶▶ ▶|</span>
            <select className="border border-gray-400 px-1">
              <option>10</option>
              <option>20</option>
              <option>50</option>
            </select>
          </div>
          <span className="text-gray-500">View 1 - 1 of 1</span>
        </div>
      </div>
    </ClinicLayout>
  );
};

export default ClinicManagePatients;
